var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.$emit('click', _vm.idx)},"mouseover":_vm.handleMouseover,"mouseleave":_vm.handleMouseLeave}},[_c('div',{staticClass:"theme-color",class:_vm.hover ? 'hover-theme' : '',style:(`background-color: ${_vm.backgroundColor}`),attrs:{"data-testid":"theme-color-cy"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }